<template>
    <el-popover
        v-model="visible"
        :popper-class="['date-range-picker-pop', `date-range-picker-pop-${type}`].join(' ')"
        :width="popWidth"
        placement="bottom-start"
        trigger="manual"
    >
        <div
            slot="reference"
            :class="[
                'date-range-picker',
                `date-range-picker-${type}`,
                visible ? 'is-active': '',
                disabled ? 'disabled' : ''
            ]"
            @mouseover="enter = true"
            @mouseleave="enter = false"
            @click="handleInputFocus"
        >
            <i
                v-if="isStart"
                slot="prefix"
                class="date-range-picker-icon el-icon-date"
            />
            <template v-if="isRange">
                <span
                    class="date-range-picker-label is-range"
                >{{ dispalyValue[0] ? dispalyValue[0] : startPlaceholder }}</span>
                <span class="date-range-picker-separator">{{ rangeSeparator }}</span>
                <span
                    class="date-range-picker-label is-range"
                >{{ dispalyValue[1] ? dispalyValue[1] : endPlaceholder }}</span>
            </template>
            <span v-else class="date-range-picker-label">
                {{ dispalyValue ? dispalyValue : placeholder }}
            </span>

            <small
                v-show="showClear"
                class="date-range-picker-label-clear el-icon-circle-close"
                @click.stop="handleClear"
            />
        </div>

        <DatePop
            :key="type"
            v-model="_value"
            :type="type"
            :is-range="isRange"
            :visible.sync="visible"
            :is-start="isStart"
            :limit="limit"
        />
    </el-popover>
</template>


<script>
import DatePop from "./DatePop";

import {
  RANGE_TYPE_WEEK,
  RANGE_TYPE_MONTH,
  RANGE_TYPE_QUARTER,
  RANGE_TYPE_HALF_YEAR,
  RANGE_TYPE_YEAR,
  TYPE_MONTH,
  TYPE_YEAR,
  TYPE_WEEK,
  TYPE_QUARTER
} from "./enums";
import Methods from "./methods";

const widths = {
  [RANGE_TYPE_WEEK]: 980,
  [RANGE_TYPE_MONTH]: 700,
  [RANGE_TYPE_QUARTER]: 700,
  [RANGE_TYPE_HALF_YEAR]: 700,
  [RANGE_TYPE_YEAR]: 700,
  [TYPE_MONTH]: 350,
  [TYPE_YEAR]: 350,
  [TYPE_WEEK]: 490,
  [TYPE_QUARTER]: 350
};

export default {
  name: "DateRangePicker",

  components: {
    DatePop
  },

  props: {
    startPlaceholder: {
      default: "起始值",
      type: String
    },

    endPlaceholder: {
      default: "截止值",
      type: String
    },

    placeholder: {
      default: "请选择",
      type: String
    },

    rangeSeparator: {
      default: "-",
      type: String
    },

    disabled: {
      default: false,
      type: Boolean
    },

    isStart: {
      default: true,
      type: Boolean
    },

    limit: {
      default: () => [],
      type: Array
    },

    value: {
      default: null,
      type: Array | String
    },

    type: {
      default: RANGE_TYPE_MONTH,
      type:
        RANGE_TYPE_WEEK |
        RANGE_TYPE_MONTH |
        RANGE_TYPE_QUARTER |
        RANGE_TYPE_HALF_YEAR |
        RANGE_TYPE_YEAR |
        TYPE_MONTH |
        TYPE_YEAR |
        TYPE_WEEK |
        TYPE_QUARTER
    },

    clearable: {
      default: false,
      type: Boolean
    }
  },

  data() {
    return {
      visible: false,
      enter: false
    };
  },

  computed: {
    popWidth() {
      return widths[this.type];
    },

    dispalyValue() {
      if (this.isRange) {
        const [startValue, endValue] = this._value || [];

        return [
          Methods[this.type].displayFormatter(startValue),
          Methods[this.type].displayFormatter(endValue, false)
        ];
      }

      return Methods[this.type].displayFormatter(this._value);
    },

    isRange() {
      return this.type.includes("range");
    },

    //    dispalyValue() {
    //      const [startValue, endValue] = this._value || [];
    //
    //      if (this.type === RANGE_TYPE_WEEK) {
    //        if (!startValue && !endValue) {
    //          return [];
    //        }
    //
    //        return [
    //          Methods[this.type].displayFormatter(startValue),
    //          Methods[this.type].displayFormatter(endValue,false)
    //        ];
    //      }
    //
    //      return [
    //        Methods[this.type].displayFormatter(startValue),
    //        Methods[this.type].displayFormatter(endValue)
    //      ];
    //    },

    showClear() {
      const hasVal = this.isRange && this.dispalyValue.every(val => val !== "") || !this.isRange && this.dispalyValue !== "";

      return this.clearable && hasVal && this.enter && !this.visible;
    },

    _value: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit("input", val);
        this.$emit("change", val);

        let parent = this.$parent || this.$root;
        let name = parent.$options.componentName;

        while (parent && (!name || name !== "ElFormItem")) {
          parent = parent.$parent;

          if (parent) {
            name = parent.$options.componentName;
          }
        }

        if (parent) {
          parent.$emit("el.form.change", val);
        }
      }
    }
  },

  mounted() {
    document.body.addEventListener("click", this.handlePopClose);
  },

  beforeDestroy() {
    document.body.removeEventListener("click", this.handlePopClose);
  },

  methods: {
    handleInputFocus() {
      if (this.disabled) {
        return;
      }

      this.visible = !this.visible;
    },

    handlePopClose(e) {
      if (!this.$el.contains(e.target)) {
        this.visible = false;
      }
    },

    handleClear() {
      if (this.isRange) {
        this._value = [];
      } else {
        this._value = "";
      }
    }
  }
};
</script>

<style lang="scss">
    .date-range-picker {
        position: relative;
        background-color: #EDF3F7;
        color: #666;
        height: 30px;
        line-height: 24px;
        outline: none;
        transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        width: 100%;
        font-size: 0;
        padding: 3px 25px 3px 17px;
        cursor: pointer;
        border-radius: 4px;
        display: inline-flex;
        align-items: center;
        .date-range-picker-icon{
            left: 0;
            border-left: 0;
            background-color:initial;
        }
        &.disabled {
            color: #c0c4cc;
            &::before {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                cursor: not-allowed;
                content: "";
                z-index: 1;
                background-color: #f5f7fa;
                opacity: 0.75;
            }
        }

        &-icon {
            width: 25px;
            height: 100%;
            text-align: center;
            font-size: 14px;
            color: #849CBE;
            background-color: rgba(216, 216, 216, 0.2);
            border-left: 1px solid #CFD8E6;
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            line-height: 30px;
        }

        &-separator {
            padding: 0 2px;
            font-size: 14px;
        }

        &-label {
            display: inline-block;
            border: none;
            outline: none;
            height: 100%;
            margin: 0;
            width: 100%;
            text-align: center;
            font-size: 12px;
            color: #666;
            background: none;
            &.is-range {
                width: calc((100% - 13px) / 2);
            }
            &-clear {
                position: absolute;
                top: 0;
                right: 25px;
                cursor: pointer;
                font-size: 14px;
                color: #c0c4cc;
                width: 25px;
                display: inline-block;
                line-height: 30px;
                text-align: center;
                &:hover{
                    color: #666;
                }
            }
        }

        &-month,
        &-monthrange,
        &-year,
        &-yearrange,
        &-week,
        &-weekrange,
        &-quarter,
        &-quarterrange {
            width: 220px;
        }

        &-icon-btn {
            margin: 0;
            position: absolute;
            font-size: 16px;
            color: #999;
            cursor: pointer;
            background-color: transparent;

            &:hover {
                color: #333;
            }

            &:disabled {
                cursor: not-allowed;
                color: #dde2e6;
            }
        }

        &-header {
            margin: 0 12px;
            text-align: center;
            border-bottom: 1px solid #ebeef5;
            position: relative;

            div {
                text-align: center;
                font-size: 14px;
                color: #333;
                line-height: 1;
                padding: 12px 0;

                &::before {
                    position: absolute;
                    top: 10px;
                    left: 50px;
                    font-size: 12px;
                    display: block;
                }
            }

            .date-range-picker-icon-btn {
                top: 12px;

                &.el-icon-d-arrow-left {
                    left: -5px;
                }

                &.el-icon-d-arrow-right {
                    right: -5px;
                }
            }

            // &-start {
            //   div {
            //     &::before {
            //       content: "起";
            //     }
            //   }
            // }

            // &-end {
            //   div {
            //     &::before {
            //       content: "止";
            //     }
            //   }
            // }
        }

        &-container {
            display: flex;
        }

        &-zone {
            flex: 1;

            .el-date-table {
                border-collapse: collapse;
                table-layout: fixed;
                width: 100%;
                td {
                    &.selected {
                        div {
                            margin: 0;
                            border-radius: 0;
                        }

                        span {
                            border-radius: 0;
                            background-color: #f00;
                        }
                    }

                    &.start-date {
                        div {
                            margin-left: 5px;
                            border-top-left-radius: 20px;
                            border-bottom-left-radius: 20px;
                        }
                    }

                    &.end-date {
                        div {
                            margin-right: 5px;
                            border-top-right-radius: 20px;
                            border-bottom-right-radius: 20px;
                        }
                    }

                    span {
                        width: 48px;
                        border-radius: 0;
                    }

                    &.in-range {
                        div {
                            background-color: #fe0;
                        }
                    }
                }
            }
        }

        &-table-wrapper {
            position: relative;
            margin: 15px;

            .date-range-picker-icon-btn {
                top: 50%;
                transform: translateY(-50%);
                z-index: 1;
                display: none;
                font-size: 20px;

                &.is-show {
                    display: block;
                }

                &.el-icon-arrow-left {
                    left: -25px;
                }

                &.el-icon-arrow-right {
                    right: -25px;
                }
            }
        }

        &-table {
            border-collapse: collapse;
            table-layout: fixed;
            width: 100%;
            td {
                padding: 4px 0;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                text-align: center;
                cursor: pointer;

                .cell {
                    height: 100%;
                    // padding: 3px 0;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    position: relative;
                }

                .inner-cell {
                    display: block;
                    // margin: 0 auto;
                    width: 100%;
                    height: 100%;
                    // position: absolute;
                    text-align: center;
                    font-size: 12px;
                    text-align: center;
                    color: #666;
                    // top: 50%;
                    // left: 50%;
                    // transform: translate(-50%, -50%);
                    border-radius: 20px;
                }

                &.in-range {
                    .cell {
                        background-color: #e8ecef;
                    }
                }

                &:hover {
                    .inner-cell {
                        background-color: #55a7fb;
                        color: #fff;
                    }
                }

                &.start-date {
                    .cell {
                        margin-left: 5px;
                        border-top-left-radius: 20px;
                        border-bottom-left-radius: 20px;
                    }
                }

                &.end-date {
                    .cell {
                        margin-right: 5px;
                        border-top-right-radius: 20px;
                        border-bottom-right-radius: 20px;
                    }
                }

                &.start-date,
                &.end-date {
                    .inner-cell {
                        background-color: #55a7fb;
                        color: #fff;
                    }
                }

                &.selected {
                    .inner-cell {
                        color: #fff;
                        background-color: #409eff;
                    }
                }

                &.disabled {
                    .cell,
                    .inner-cell {
                        background-color: transparent;
                        cursor: not-allowed;
                    }
                    .inner-cell {
                        color: #c0c4cc;
                    }
                }
            }
        }

        &-pop {
            padding: 0;
        }
    }

    .date-range-picker-pop {
        &-month,
        &-monthrange,
        &-year,
        &-yearrange,
        &-quarter,
        &-quarterrange {
            td {
                .inner-cell {
                    line-height: 32px;
                }
            }
        }

        &-weekrange,
        &-week {
            td {
                .inner-cell {
                    border-radius: 30px;
                    padding: 7px;
                    line-height: 17px;
                }

                span {
                    display: block;
                }
            }

            .date-range-picker-table-wrapper {
                height: 225px;
                margin: 15px 25px;
            }
        }
    }
</style>
